export const NAMESPACE = 'useStripeSubscriptions';

export const STRIPE_SUBSCRIPTIONS_KEY = 'stripeSubscriptions';

export const HAS_FETCHED_KEY = 'hasFetched';

export const IS_FETCHING_KEY = 'isFetching';
